import React, { useCallback, useState } from 'react';

import { format } from 'date-fns';

import {
  FaWhatsapp,
  FaCheckCircle,
  FaSpinner,
  FaCircle,
  FaEnvelope,
} from 'react-icons/fa';
import { Button } from 'react-bootstrap';

import api from '../../../services/api';

import { useToast } from '../../../hooks/toast';

import Modal from '../../../components/Modal';
import Agendamento from '../../../components/Agendamento';
import { Spinner } from '../../../components/Agendamento/styles';

import getResponseErrors from '../../../utils/getResponseErrors';

import { IAgendamento } from '../index';
import { PacienteLinha, PacienteLista } from '../styles';
import { ORIGEM_NOTIFICACAO, htmlDecode } from '../../../utils/funcoes';

type ITemTabela = {
  agendamento: IAgendamento;
  conectado: boolean;
};

const ItemTabela: React.FC<ITemTabela> = ({ agendamento, conectado }) => {
  const { addToast } = useToast();

  const [loading, setLoading] = useState(false);
  const [showModalMensagem, setShowModalMensagem] = useState(false);
  const [mensagemCobranca, setMensagemCobranca] = useState<string>();
  const [dataUltimoEnvioFormatado, setDataUltimoEnvioFormatado] = useState(
    agendamento.DataUltimaNotificacaoFormatado,
  );
  const [showAgendamento, setShowAgendamento] = useState(false);

  const handleSalvaNotificacao = useCallback(async () => {
    try {
      setLoading(true);
      const dados = {
        NotAgeCodigo: agendamento.AgeCodigo,
        NotMetodo: 'Whatsapp',
      };
      await api.post(`/agendamentos/notificacao`, dados);
      setDataUltimoEnvioFormatado(format(new Date(), 'dd/MM/yyyy HH:mm'));
    } catch (error) {
      const mensagemErro = getResponseErrors(error);
      addToast({
        title: 'Não foi possível salvar a notificação',
        type: 'error',
        description: mensagemErro,
      });
    } finally {
      setLoading(false);
    }
  }, [addToast, agendamento.AgeCodigo]);

  const handleEnviaConfirmacao = useCallback(
    async (agendament: IAgendamento) => {
      if (!conectado) {
        const textoDecode = htmlDecode(agendament.textoMensagem);
        const textoMensagem = encodeURIComponent(textoDecode);

        const linkWhatsapp = `https://api.whatsapp.com/send?phone=55${agendament.PacCelular}&text=${textoMensagem}`;
        window.open(linkWhatsapp, '_blank');
      }
      if (conectado) {
        const { textoMensagem } = agendament;

        try {
          setLoading(true);
          const dados = {
            message: textoMensagem,
            type: ORIGEM_NOTIFICACAO.CONFIRMACAO_AGENDAMENTOS,
            numeroTo: `55${agendament.PacCelular}`,
            // numeroTo: `5524981158580`,
          };

          const retornoEnvio = await api.put(
            `/whatsapp/sendmessage/${agendament.AgeCodigo}`,
            dados,
          );
          if (retornoEnvio.data.error === true) {
            addToast({
              title: 'Não foi possível salvar a notificação',
              type: 'error',
              description: retornoEnvio.data.message,
            });
          } else {
            setDataUltimoEnvioFormatado(format(new Date(), 'dd/MM/yyyy HH:mm'));
          }
        } catch (error) {
          const mensagemErro = getResponseErrors(error);
          addToast({
            title: 'Não foi possível salvar a notificação',
            type: 'error',
            description: mensagemErro,
          });
        } finally {
          setLoading(false);
        }
      }
    },
    [addToast, conectado],
  );

  const handleExibeMensagemConfirmacao = useCallback(
    async (agendament: IAgendamento) => {
      const textoDecode = htmlDecode(agendament.textoMensagem);

      setMensagemCobranca(textoDecode.replace(/\n/g, '<br />'));
      setShowModalMensagem(true);
    },
    [],
  );

  const handleFecharModal = useCallback(() => {
    setMensagemCobranca(undefined);
    setShowModalMensagem(false);
  }, []);

  return (
    <>
      {showModalMensagem && mensagemCobranca && (
        <Modal
          show={showModalMensagem}
          titulo="Mensagem de Confirmação"
          handleFecharModal={handleFecharModal}
        >
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: mensagemCobranca,
            }}
          />
        </Modal>
      )}
      {showAgendamento && (
        <Modal
          show={showAgendamento}
          titulo="Agendamento"
          handleFecharModal={
            () => {
              setShowAgendamento(false);
            }
            // eslint-disable-next-line react/jsx-curly-newline
          }
        >
          <Agendamento
            agendaId={agendamento.AgeConfCodigo}
            perfilId={undefined}
            data={undefined}
            AgeCodigo={agendamento.AgeCodigo}
            handleFecharAgendamento={() => {
              setShowAgendamento(false);
            }}
          />
        </Modal>
      )}

      <PacienteLinha
        className="row no-gutters"
        key={`age-${agendamento.AgeCodigo}`}
        data-id={agendamento.AgeCodigo}
      >
        <div className="col-md-2 col-lg-1">
          <PacienteLista>{agendamento.AgeDataFormatada}</PacienteLista>
        </div>
        <div className="col-md-2 col-lg-1">
          <PacienteLista>{agendamento.AgeHoraFormatada}</PacienteLista>
        </div>
        <div className="col-md-3 col-lg-2">
          <PacienteLista>{agendamento.ConNome}</PacienteLista>
        </div>
        <div className="col-md-3 col-lg-2">
          <PacienteLista>{agendamento.PacNome}</PacienteLista>
        </div>
        <div className="col-md-2 col-lg-1">
          <PacienteLista>{agendamento.PacTelefonesFormatado}</PacienteLista>
        </div>
        <div className="col-md-2 col-lg-1">
          <PacienteLista>{agendamento.AgeStatusFormatado}</PacienteLista>
        </div>
        <div className="col-md-2 col-lg-1">
          <PacienteLista>{dataUltimoEnvioFormatado}</PacienteLista>
        </div>
        <div className="col-md-2 col-lg-1">
          <PacienteLista>
            <Button
              type="button"
              variant="outline-success"
              size="sm"
              data-id={agendamento.AgeCodigo}
              onClick={() => {
                setShowAgendamento(true);
              }}
            >
              Ver Agendamento
            </Button>
          </PacienteLista>
        </div>
        <div className="col-md-2 col-lg-2">
          <PacienteLista>
            <Button
              type="button"
              variant="success"
              size="sm"
              className="ml-1"
              data-id={agendamento.AgeCodigo}
              onClick={() => handleEnviaConfirmacao(agendamento)}
            >
              <FaWhatsapp size={16} />
            </Button>

            {loading ? (
              <Spinner className="px-2 py-1 border rounded ml-1">
                <FaSpinner size={17} />
              </Spinner>
            ) : (
              <Button
                type="button"
                variant={
                  dataUltimoEnvioFormatado !== ''
                    ? 'success'
                    : 'outline-secondary'
                }
                size="sm"
                className="ml-1"
                data-id={agendamento.AgeCodigo}
                onClick={() => handleSalvaNotificacao()}
              >
                {dataUltimoEnvioFormatado !== '' ? (
                  <FaCheckCircle size={16} />
                ) : (
                  <FaCircle size={16} />
                )}
              </Button>
            )}
            <Button
              type="button"
              variant="info"
              size="sm"
              className="ml-1"
              onClick={() => handleExibeMensagemConfirmacao(agendamento)}
            >
              <FaEnvelope size={16} />
            </Button>
          </PacienteLista>
        </div>
      </PacienteLinha>
    </>
  );
};

export default ItemTabela;
